import { handleActions } from "redux-actions";
import { set } from "../actions/location";

const defaultState = {
  lat: undefined,
  lng: undefined,
};

export const locationSelector = ({ location }) => (location);

const locationReducer = handleActions(
  {
    [set]: (state, { payload }) => ({
      ...state,
      lat: payload.lat,
      lng: payload.lng,
    }),
  },
  defaultState,
);

export default locationReducer;
